import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import orangeBackground from "../images/orange-background.png";

interface GetStartedProps {
    height: number;
}

export const About = ({ height }: GetStartedProps) => {
    const [videoSize, setVideoSize] = useState([0, 0]);

    useLayoutEffect(() => {
        function updateSize() {
            let innerWidth = window.innerWidth;
            if (innerWidth > 750) innerWidth = 750;
            innerWidth = innerWidth * 0.9;
            setVideoSize([innerWidth, innerWidth * 0.6]);
        }
        window.addEventListener("resize", updateSize);
        updateSize();
        return () => window.removeEventListener("resize", updateSize);
    }, []);

    return (
        <section
            id="About"
            style={{ minHeight: `${height}px` }}
            className="About"
        >
            <div className="content">
                <h2 className="section-header">About Alchemie</h2>
                {/* <p style={{ width: `${videoSize[0]}px` }}>
                    Alchemie is emerging as the innovative lead of truly
                    inclusive interactive learning tools for STEM.
                </p>
                <button>Learn More</button> */}
                <iframe
                    title="Video about Alchemie Solutions company"
                    className="video"
                    height={videoSize[1]}
                    width={videoSize[0]}
                    src="https://youtube.com/embed/K-3A9VP5CRw"
                ></iframe>
            </div>
        </section>
    );
};
